  import React, { useEffect, useState } from "react";
  import { getCookieValue } from "../../../cookieHelper";
  import Loader from "../../shared/Loader/Loader";
  import "./PublicHome.scss";
  const PublicHome = (props: any) => {
    let [loaderFlag, setLoaderFlag] = useState(false);

    const checkIFCookiePresent = (cookieValue: string) => {    
      if(cookieValue){
        setLoaderFlag(true);
      } else {
        setLoaderFlag(false);
        window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`;
      }
    }

  useEffect(()=>{
    let interval: any;
    let cookieValue: string = getCookieValue(`${process.env.REACT_APP_ENV}IdToken`) || "";
    if(cookieValue){
      setLoaderFlag(true);
    }   
      if(!cookieValue){
        setLoaderFlag(false);
        document.title="Halo";
        if((window.location.href !== `${window.location.origin}/`)){
          if((window.location.href.search(/redirectUrl/gi) === -1) && (window.location.href.search(/logout/gi) === -1)){
            window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}/?redirectUrl=${encodeURIComponent(window.location.href)}`;
          } else{
            if((window.location.href.search(/redirectUrl/gi) === -1)){
              window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`;
            } else {
              let decodedURL = decodeURIComponent(window.location.href);
              let redURL = decodedURL.slice(decodedURL.indexOf("redirectUrl") + "redirectUrl".length + 1);
              window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}/?redirectUrl=${encodeURIComponent(redURL)}`;
            }            
          }
        } else {
          window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}`;
        }

      } else {
        checkIFCookiePresent(cookieValue);
      }    
  },[]);
  
  return (
    <div data-testid="loader" className="PublicHomeContainer">
      <Loader showLoader={true} />
      {/* <Loader showLoader={loaderFlag} />
      <div className="Banner-section">
        <HeadSlider authProps={{...props}}></HeadSlider>
      </div> */}
    </div>
  );
};

  export default PublicHome;
